import Modal from 'components/Modal';
import { NextButton, PrevButton, Wrapper } from './QuestSwiper.styles';
import { Swiper, SwiperSlide } from 'swiper/react';
import QuestsSwiperCard from '../QuestsSwiperCard';
import SwiperCore, { A11y, Navigation, Pagination } from 'swiper';
import { useEffect, useRef, useState } from 'react';
import ChevronLeft from 'Icons/ChevronLeft';
import ChevronRight from 'Icons/ChevronRight';
import { theme } from 'twin.macro';
// import useData from 'store/useData';
import { QuestsSwiperProps } from './QuestSwiper.types';
import { useNavigate } from 'react-router-dom';
import useMission from 'store/useMission';

const QuestSwiper = ({ isOpen, onClose }: QuestsSwiperProps) => {
  // const { quests, questsData } = useData();
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);
  // eslint-disable-next-line
  const [swiper, setSwiper] = useState<SwiperCore | null>(null);
  const navigate = useNavigate();
  const { setRefresh, setSelectedQuest, setMission, setMissionType } =
    useMission();
  const [data, setData] = useState<any>(null);

  const handleStart = (item: any) => {
    setSelectedQuest(item);
    if (item.starterMission) {
      setMissionType(item.starterMission ? 'starter' : '');
      setMission(item.starterMission);
    } else setMission(item.missions[0]);
    setRefresh(true);
    navigate('/map');
    onClose();
  };

  useEffect(() => {
    const data = localStorage.getItem('allData');
    setData(JSON.parse(data || ''));
    // eslint-disable-next-line
  }, [localStorage.getItem('allData')]);

  return (
    <Modal isOpen={isOpen} closeModal={() => {}}>
      <Wrapper>
        <Swiper
          slidesPerView={1}
          pagination={true}
          modules={[Pagination, A11y, Navigation]}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onSwiper={(swiperCore) => setSwiper(swiperCore)}
          className="mySwiperII"
        >
          {data &&
            data.map((quest: any, index: number) => {
              const mission = quest.starterMission || quest.missions[0];
              return (
                <SwiperSlide key={quest._id + index} className="py-14">
                  <QuestsSwiperCard
                    missionName={mission?.name}
                    missionCoins={mission?.coins}
                    missionLevel={mission?.level}
                    missionDistance={mission?.distance}
                    onStart={() => handleStart(quest)}
                    onClose={onClose}
                  />
                </SwiperSlide>
              );
            })}

          <PrevButton
            ref={prevRef}
            hasAfter={true}
            bgColor={theme`colors.lightBlue`}
            afterBg={theme`colors.blue`}
            isRounded={false}
          >
            <ChevronLeft />
          </PrevButton>
          <NextButton
            ref={nextRef}
            hasAfter={true}
            bgColor={theme`colors.lightBlue`}
            afterBg={theme`colors.blue`}
            isRounded={false}
          >
            <ChevronRight />
          </NextButton>
        </Swiper>
      </Wrapper>
    </Modal>
  );
};

export default QuestSwiper;
